import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../../modules/auth'
import { Link } from 'react-router-dom'
import { SurveyPostpone } from './components/SurveyPostpone'
import { SurveyInfo } from './components/SurveyInfo'
import {
  fetchUserSurveyApplications,
  fetchUserSurveyInfo,
} from '../CustomController'


const portal_link = process.env.REACT_APP_PORTAL_LINK;
const apiurl = process.env.REACT_APP_API_URL;

const StudentSurveyBox = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()

    const [showbutton, setShowbutton] = React.useState(false)
  console.log(currentUser)
  const [data, setData]: any = React.useState(null)
  useEffect(() => {
    fetchUserSurveyApplications().then((res: any) => {
      console.log(res)
      setData(res?.data?.data)
    })
  }, [currentUser])
    console.log(portal_link)
  useEffect(() => {
    fetchUserSurveyInfo().then((res: any) => {
      if (res.data === '1') setShowbutton(false)
      else setShowbutton(false)
    })
  }, [])

  const i = 5
  return (
      <>
          {data?.length > 0 && <><SurveyInfo showbutton={showbutton} />         
              <div className='alert alert-info p-4'>
                  <strong>Not:</strong> Üzerinizde tanımlı zorunlu anket bulunması durumunda anketi doldurmadan ya da erteleme yapmadan tek şifre sistemine giriş yapmanız mümkün olmayacaktır. Zorunlu anketleri tamamladıktan ya da erteleme yaptıktan sonra tek şifre sistemine tekrar giriş yapabilirsiniz.
                  <br /><a className="btn btn-success" href={portal_link}>Tek Şifre Sistemine Giriş</a>
              </div>
           <SurveyPostpone />
      <div className={`card card-xl-stretch mb-xl-8 mt-5`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-10'>
          <h3 className='card-title align-items-start'>
            <span className='card-label fw-bold fs-3 mb-1'>Değerlendirme Anketleri</span>
          </h3>
        </div>
        <div className='card-body flex-column overflow-auto'>
          {data?.map((item: any, index: any) => (
            <Link
              to={`/surveyanswer/${item?.surveyGuid}/${item?.surveyApplicationId}/${item?.courseId}`}
              target='_blank'
              rel='noopener noreferrer'
              style={item?.isCompleted ? {pointerEvents: 'none'} : {pointerEvents: 'auto'}}
            >
              <div
                key={index}
                className={`${
                  item.isCompleted ? 'bg-success' : 'bg-warning'
                } rounded p-4 mb-3 d-flex align-items-center  `}
                style={{
                  opacity: item.isCompleted ? 0.7 : 1,
                  cursor: item.isCompleted ? 'not-allowed' : 'pointer',
                }}
              >
                <span style={{marginRight: '10px'}}>
                  <i className='fa fa-list-alt' style={{fontSize: '1.2em', color: 'black'}}></i>
                </span>
                <div className='m-2'>
                          <h4 className='mb-0'>{item.courseName} { item.isRequired ? '(Zorunlu)' : '' }</h4>

                  <h6 className='mb-0 fw-light'>
                    {' '}
                    {item.isCompleted ? 'Tamamlandı' : 'Tamamlanmadı'}
                  </h6>
                </div>
              </div>
            </Link>
          ))}
        </div>
              </div></>}
    </>
  )
}

export {StudentSurveyBox}
